<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import createModal from "./create_modal.vue";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: {
    title: "İp Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    createModal,
    Datatable
  },
  mixins: [ datatableMixin],
  data() {
    return {
        title: "İP LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "İP LİSTESİ",
            active: true,
          },
        ],

        columns: [
          { name: 'İp', key: 'ip', orderable:true, width: 150 },
          { name: 'Müşteri Adı', key: 'username', className: 'text-start', width: 150  }
        ],
        tableData: {
          detail: false,
          excel: false,
          searchable:{
            visible:true,
            placeholder:"Ip de Ara"
          }
        },
        endpoint: '/ips',
    };
  },

  methods: {

    async loadPage() {
          
        this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
        
        const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
        if (this.params.page === 1) {
            this.tableData.data = response.data.data;
        } else {
            this.tableData.data = [...this.tableData.data, ...response.data.data];
        }
    
        this.tableData.pagination = response.data.meta;
        this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
    },
        
    create(){
      this.list = {}
      this.$parent.$bvModal.show('modal-scoped')
    },

    remove(props){
        // eslint-disable-next-line no-console
        console.log(props)
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <create-modal :list="list" @loadItems="loadItems"/>

    <div class="row"> 
      <div class="col-12">
        <Datatable 
              :columns="columns" 
              :tableData="tableData" 
              @sort-column="handleSortColumn"
              @search-query="reLoadPage"
              @excel-export="excelExport"
              :loading="isLoading"
              :poading="pageLoading">
            
        <template #button>
          <button class="btn btn-sm btn-success" @click="create()">Yeni Oluştur</button>
        </template>

        <template #status="{ row }">
          <span v-if="row.status_id"  class="badge rounded-pill bg-success"><i class="fa fa-check"></i> Aktif </span>
          <span v-if="!row.status_id"  class="badge rounded-pill bg-danger"><i class="fa fa-times"></i> Pasif </span>
        </template> 

        </Datatable>
      </div>
    </div>
  </Layout>
</template>